import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { YMaps, Map, Placemark, Circle } from '@pbe/react-yandex-maps';
import ConsultationBlock from '../../components/cta/ConsultationBlock';

export const WorkArea = () => {
  useEffect(() => { document.title = "Где мы работаем | Комплекс строй"; }, []);

  const center = [55.518754, 36.96065];
  const locations = ["Селятино", "Апрелевка", "Киевский", "Калининец", "Глаголево", "Новоглаголево", "Софьино", "Шишкин Лес", "Рассудово", "Яковлевское", "Кузнецово"];

  return (
    <div style={{ paddingTop: 'var(--nav-height)' }}>
      {/* Контент карты в своем контейнере */}
      <Container className="py-5 mb-5 work-area-content">
        <Row className="gy-5 align-items-center">
          <Col lg={5} className="order-2 order-lg-1">
            <h1 className="fw-bold display-5 mb-4">География работ</h1>
            <p className="text-muted fs-5 mb-4">Наш основной штаб в <strong>пос. Селятино</strong>. Оперативно выезжаем в радиусе 15-20 км.</p>
            <div className="mb-4">
              <h5 className="fw-bold text-uppercase small text-muted mb-3">Основные направления:</h5>
              <Row>
                <Col xs={6}>
                  <ul className="list-unstyled">
                    {locations.slice(0, 6).map(l => <li key={l} className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>{l}</li>)}
                  </ul>
                </Col>
                <Col xs={6}>
                  <ul className="list-unstyled">
                    {locations.slice(6).map(l => <li key={l} className="mb-2"><i className="bi bi-check2 text-accent me-2"></i>{l}</li>)}
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>

          <Col lg={7} className="order-1 order-lg-2">
            <div className="shadow-lg rounded-4 overflow-hidden border bg-white p-1" style={{ height: '500px' }}>
              <YMaps query={{ load: "package.full" }}>
                <Map defaultState={{ center: center, zoom: 10, controls: ["zoomControl"] }} width="100%" height="100%" modules={["control.ZoomControl"]}>
                  <Placemark geometry={center} options={{ iconColor: '#ff6b00' }} />
                  <Circle defaultGeometry={[center, 15000]} options={{ fillColor: "#ff6b0022", strokeColor: "#ff6b00", strokeWidth: 2 }} />
                </Map>
              </YMaps>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Блок консультации ВНЕ основного контейнера — теперь он на всю ширину с серым фоном */}
      <ConsultationBlock />
    </div>
  );
};
